const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content picker component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assignmentSettings', ['Application', function(Application) {
  return {
    restrict: 'E',
    scope: {
      assignment: '=',
      values: '=',
      addMessage: '&',
      content: '=',
      helptext: '=?',
      includeNotifications: '@?',
      originalDue: '=?',
      editing: '=?'
    },
    template: require('../../../templates/directives/assignments/assignment-settings.html'),
    controller: ['$scope', '$window', function ($scope) {
      var self = this;
      self.hideNotifs = $scope.includeNotifications && $scope.includeNotifications === 'false';
      self.addMessage = function(message) {
        $scope.addMessage({message: message});
      };

      self.max = null;

      self.decreaseNotified = false;
      self.disableReassignmentsToggle = $scope.editing && $scope.content

      self.decDueDays = function(){
        if ($scope.values.due_date < 2) {
          return;
        }

        if (self.max === null) {
          self.max = $scope.values.due_date;
        }

        if ($scope.values && $scope.values._id && $scope.values.due_date === self.max && !self.decreaseNotified) {
          Application.messaging.addMessage({type: 'info', text: 'Please be aware that decreasing the due date could result in an asignee missing reminder messaging.', duration: 20});
          self.decreaseNotified = true;
        }

        $scope.values.due_date = $scope.values.due_date - 1;
      };

      self.incDueDays = function(){
        if (self.max === null) {
          self.max = $scope.values.due_date;
        }

        $scope.values.due_date = $scope.values.due_date + 1;
      };

      self.decDueHiredDays = function(){
        if ($scope.values.due_days_after_hired < 1) {
          return;
        }

        if (self.max === null) {
          self.max = $scope.values.due_days_after_hired;
        }

        if ($scope.values && $scope.values._id && $scope.values.due_days_after_hired === self.max && !self.decreaseNotified) {
          Application.messaging.addMessage({type: 'info', text: 'Please be aware that decreasing the due date could result in an asignee missing reminder messaging.', duration: 20});
          self.decreaseNotified = true;
        }

        $scope.values.due_days_after_hired = $scope.values.due_days_after_hired - 1;
      };

      self.incDueHiredDays = function(){
        if (self.max === null) {
          self.max = $scope.values.due_days_after_hired;
        }

        $scope.values.due_days_after_hired = $scope.values.due_days_after_hired + 1;
      };

      self.toggleAllowRecompletion = () => {
        $scope.values.require_recompletion = !$scope.values.require_recompletion;
      };

    }],
    controllerAs: 'settings'
  };
}]);